function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
var MixinModule = require('./mixinmodule');
var _require = require('../../store/lib/withdrawal-quote'),
  quoteIsExpired = _require.quoteIsExpired,
  verifyQuote = _require.verifyQuote;
function authorizedSigners(mod) {
  var _mod$app;
  var signers = [];
  var own = String(mod.publicKey || '').trim();
  if (own) {
    signers.push(own);
  }
  var configured = mod.delegated_payment_publickeys;
  var options = (_mod$app = mod.app) === null || _mod$app === void 0 || (_mod$app = _mod$app.options) === null || _mod$app === void 0 || (_mod$app = _mod$app.mixin) === null || _mod$app === void 0 ? void 0 : _mod$app.delegated_payment_publickeys;
  var allowed = Array.isArray(configured) ? configured : Array.isArray(options) ? options : [];
  var _iterator = _createForOfIteratorHelper(allowed),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var candidate = _step.value;
      var key = String(candidate || '').trim();
      if (key && !signers.includes(key)) {
        signers.push(key);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return signers;
}
function verifiedQuoteSigner(mod, data, signature) {
  var _iterator2 = _createForOfIteratorHelper(authorizedSigners(mod)),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var key = _step2.value;
      if (verifyQuote(mod.app, data, signature, key)) {
        return key;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return '';
}
function decimalUnits(value) {
  var text = String(value !== null && value !== void 0 ? value : '').trim();
  if (!/^\d+(\.\d+)?$/.test(text)) {
    return null;
  }
  var _text$split = text.split('.'),
    _text$split2 = _slicedToArray(_text$split, 2),
    whole = _text$split2[0],
    _text$split2$ = _text$split2[1],
    fraction = _text$split2$ === void 0 ? '' : _text$split2$;
  return BigInt(whole) * 100000000n + BigInt((fraction + '00000000').slice(0, 8));
}
function paidToTreasury(tx, treasury) {
  var total = 0n;
  var addressed = false;
  var _iterator3 = _createForOfIteratorHelper((tx === null || tx === void 0 ? void 0 : tx.to) || []),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var slip = _step3.value;
      if (String((slip === null || slip === void 0 ? void 0 : slip.publicKey) || '') !== treasury) {
        continue;
      }
      addressed = true;
      try {
        var _slip$amount;
        total += BigInt((_slip$amount = slip.amount) !== null && _slip$amount !== void 0 ? _slip$amount : 0);
      } catch (err) {
        return {
          addressed: false,
          total: 0n
        };
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return {
    addressed: addressed,
    total: total
  };
}
function pairsFromQuote(data) {
  var transfers = Array.isArray(data === null || data === void 0 ? void 0 : data.transfer_uuids) ? data.transfer_uuids : null;
  var payments = Array.isArray(data === null || data === void 0 ? void 0 : data.payment_uuids) ? data.payment_uuids : null;
  if (!transfers || !payments || transfers.length !== payments.length || !transfers.length) {
    return null;
  }
  var pairs = [];
  var seenTransfers = new Set();
  var seenPayments = new Set();
  for (var i = 0; i < transfers.length; i += 1) {
    var transfer = String(transfers[i] || '').trim();
    var payment = String(payments[i] || '').trim();
    if (!transfer || !payment || seenTransfers.has(transfer) || seenPayments.has(payment)) {
      return null;
    }
    if (!/^[1-9]\d*$/.test(transfer)) {
      return null;
    }
    seenTransfers.add(transfer);
    seenPayments.add(payment);
    pairs.push({
      transfer: transfer,
      payment: payment
    });
  }
  return pairs;
}
function addressIsValid(mod, ticker, address) {
  var probe = {
    ticker: ticker,
    chain_id: '',
    mixin: mod
  };
  try {
    return MixinModule.prototype.validateAddress.call(probe, address) === true;
  } catch (err) {
    return false;
  }
}
function receiveStoreWithdrawal(_x, _x2, _x3) {
  return _receiveStoreWithdrawal.apply(this, arguments);
}
function _receiveStoreWithdrawal() {
  _receiveStoreWithdrawal = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(mod, tx, peer) {
    var _tx$returnMessage, _tx$from, _mod$app$wallet$conve;
    var message, sender, data, claimed, signer, selfSigned, treasury, ticker, address, pairs, required, paid, recorded, _t, _t2, _t3, _t4, _t5, _t6, _t7, _t8, _t9, _t0, _t1, _t10, _t11;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          message = (tx === null || tx === void 0 || (_tx$returnMessage = tx.returnMessage) === null || _tx$returnMessage === void 0 ? void 0 : _tx$returnMessage.call(tx)) || {};
          if (!(message.request !== 'store-withdrawal' || !message.data)) {
            _context.n = 1;
            break;
          }
          return _context.a(2, {
            err: 'That transaction is not a store withdrawal.'
          });
        case 1:
          sender = String(((_tx$from = tx.from) === null || _tx$from === void 0 || (_tx$from = _tx$from[0]) === null || _tx$from === void 0 ? void 0 : _tx$from.publicKey) || '').trim();
          if (!(!tx.signature || !sender)) {
            _context.n = 2;
            break;
          }
          return _context.a(2, {
            err: 'The withdrawal transaction is not signed.'
          });
        case 2:
          if (!(typeof tx.isValid === 'function' && tx.isValid() !== true)) {
            _context.n = 3;
            break;
          }
          return _context.a(2, {
            err: 'The withdrawal transaction signature is not valid.'
          });
        case 3:
          data = message.data;
          claimed = String(data.publickey || '').trim();
          signer = verifiedQuoteSigner(mod, data, message.signature);
          if (signer) {
            _context.n = 4;
            break;
          }
          selfSigned = claimed && verifyQuote(mod.app, data, message.signature, claimed);
          console.error('Mixin store withdrawal quote was rejected', {
            claimed_publickey: claimed,
            delivering_peer: String((peer === null || peer === void 0 ? void 0 : peer.publicKey) || ''),
            transaction_signer: sender,
            reason: selfSigned ? 'signer is not an authorized store' : 'signature is not valid'
          });
          return _context.a(2, {
            err: selfSigned ? 'The store that signed this withdrawal quote is not authorized.' : 'The store withdrawal quote signature is not valid.'
          });
        case 4:
          if (!quoteIsExpired(data.timestamp)) {
            _context.n = 5;
            break;
          }
          return _context.a(2, {
            err: 'The withdrawal quote has expired.'
          });
        case 5:
          treasury = String(mod.publicKey || '').trim();
          if (!(!claimed || claimed !== treasury && claimed !== signer)) {
            _context.n = 6;
            break;
          }
          console.error('Mixin store withdrawal quote was rejected', {
            claimed_publickey: claimed,
            signer: signer,
            reason: 'payment recipient is not the treasury or the authorized signer'
          });
          return _context.a(2, {
            err: 'The withdrawal is not addressed to an authorized treasury.'
          });
        case 6:
          ticker = String(data.ticker || '').trim();
          address = String(data.withdrawal_address || '').trim();
          if (!(!ticker || data.ticker !== ticker.toUpperCase())) {
            _context.n = 7;
            break;
          }
          return _context.a(2, {
            err: 'The withdrawal ticker is not valid.'
          });
        case 7:
          if (addressIsValid(mod, ticker, address)) {
            _context.n = 8;
            break;
          }
          return _context.a(2, {
            err: 'The withdrawal address is not valid for this cryptocurrency.'
          });
        case 8:
          pairs = pairsFromQuote(data);
          if (pairs) {
            _context.n = 9;
            break;
          }
          return _context.a(2, {
            err: 'The withdrawal quote identifiers are not valid.'
          });
        case 9:
          required = BigInt((_mod$app$wallet$conve = mod.app.wallet.convertSaitoToNolan(data.amount)) !== null && _mod$app$wallet$conve !== void 0 ? _mod$app$wallet$conve : 0);
          paid = paidToTreasury(tx, data.publickey);
          if (!(!paid.addressed || paid.total < required)) {
            _context.n = 10;
            break;
          }
          return _context.a(2, {
            err: 'The transaction does not pay the treasury the required SAITO amount.'
          });
        case 10:
          _context.p = 10;
          _t = mod.database;
          _t2 = String(data.timestamp);
          _t3 = sender;
          _t4 = ticker;
          _t5 = String(data.amount);
          _t6 = String(data.withdrawal_amount);
          _t7 = address;
          _t8 = tx.signature;
          _t9 = typeof tx.serialize_to_web === 'function' ? tx.serialize_to_web(mod.app) || '' : '';
          _context.n = 11;
          return sendingAddress(mod, ticker);
        case 11:
          _t0 = _context.v;
          _t1 = pairs;
          _t10 = JSON.stringify({
            transfer_uuids: data.transfer_uuids,
            payment_uuids: data.payment_uuids,
            quote_signature: String(message.signature || '')
          });
          _context.n = 12;
          return _t.recordStoreWithdrawal.call(_t, {
            request_id: _t2,
            sender: _t3,
            ticker: _t4,
            saito_amount: _t5,
            withdrawal_amount: _t6,
            withdrawal_address: _t7,
            saito_tx_sig: _t8,
            saito_tx: _t9,
            outbound_sender: _t0,
            pairs: _t1,
            payload: _t10
          });
        case 12:
          recorded = _context.v;
          return _context.a(2, {
            transfer_id: recorded.transfer_id,
            replayed: recorded.replayed === true,
            message: 'A manual store withdrawal was recorded. The external cryptocurrency has not been sent.'
          });
        case 13:
          _context.p = 13;
          _t11 = _context.v;
          return _context.a(2, {
            err: (_t11 === null || _t11 === void 0 ? void 0 : _t11.message) || 'The withdrawal could not be recorded.'
          });
      }
    }, _callee, null, [[10, 13]]);
  }));
  return _receiveStoreWithdrawal.apply(this, arguments);
}
function sendingAddress(_x4, _x5) {
  return _sendingAddress.apply(this, arguments);
}
function _sendingAddress() {
  _sendingAddress = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(mod, ticker) {
    var _mod$database;
    var crypto, found, _t12;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          crypto = (mod.crypto_mods || []).find(function (item) {
            return item.ticker === ticker;
          });
          if (!(!(crypto !== null && crypto !== void 0 && crypto.asset_id) || typeof ((_mod$database = mod.database) === null || _mod$database === void 0 ? void 0 : _mod$database.findAddress) !== 'function')) {
            _context2.n = 1;
            break;
          }
          return _context2.a(2, '');
        case 1:
          _context2.p = 1;
          _context2.n = 2;
          return mod.database.findAddress({
            assetId: crypto.asset_id,
            publicKey: mod.publicKey
          });
        case 2:
          found = _context2.v;
          return _context2.a(2, String((found === null || found === void 0 ? void 0 : found.address) || ''));
        case 3:
          _context2.p = 3;
          _t12 = _context2.v;
          return _context2.a(2, '');
      }
    }, _callee2, null, [[1, 3]]);
  }));
  return _sendingAddress.apply(this, arguments);
}
module.exports = {
  receiveStoreWithdrawal: receiveStoreWithdrawal,
  authorizedSigners: authorizedSigners,
  decimalUnits: decimalUnits
};